import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

interface IProps {
    onClose: () => void;
}

interface IState {}

// 活动细则
class RuleModal extends BaseComponent<IProps, IState> {
    render() {
        const { onClose } = this.props;
        return (
            <div className="rule-modal">
                <div className="rule-content">
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="rule-text">
                        【任务说明】
                        <br />
                        1、被邀请的好友必须为在《我自为道》中未注册创角的用户，被邀请用户下载游戏后，进行注册创角，在此页面提交自己的角色编号和手机号，成功后被邀请用户即可获取【宁琴·暖夜】皮肤。
                        <br />
                        2、被邀请用户成功获取【宁琴·暖夜】皮肤，并通过官方核实后，邀请人将获得【萧汐儿·暖夜】皮肤。
                        <br />
                        3、被邀请用户在此页面提交手机号码时，务必填写邀请人的邀请码。
                        <br />
                        【领取规则】
                        <br />
                        1、该活动仅限iOS端及官方安卓包用户登录领取。
                        <br />
                        2、活动奖励将发放至用户提交的角色编号所属的游戏账户内。
                        <br />
                        【发放时间】
                        <br />
                        皮肤奖励领取方法请查看游戏内社区公告，成功获取奖励资格的用户在社区完成领取步骤后，皮肤将在3个工作日内发放至用户邮箱，如有问题请联系游戏内在线客服。
                    </div>
                </div>
            </div>
        );
    }
}

export default RuleModal;
